const { registerBlockType } = wp.blocks;
const { useState, useEffect } = wp.element;

registerBlockType('movistar-addons/block-phantasia-carousel', {
    title: 'Carrusel de Fantasia',
    icon: 'smiley',
    category: 'common',
    edit: () => {
        const [data, setData] = useState(null);

        useEffect(() => {
            fetch('/wp-json/movistar/v1/datos')
                .then(response => response.json())
                .then(data => setData(data))
                .catch(error => console.error('Error:', error));
        }, []);

        if (!data) {
            return 'Cargando...';
        }

        return (
            <div className="movistar-datos">
                {data.map(item => (
                    <div className="equipo" key={item.IdEquipo}>
                        <h2>{item.Nombre}</h2>
                        <p>{item.Modelo}</p>
                        <p>Precio: {item.PrecioEquipo}</p>
                    </div>
                ))}
            </div>
        );
    },
    save: () => {
        return null; // El contenido se renderiza dinámicamente en el lado del servidor
    }
});
